'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkbox = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(Checkbox, _React$Component);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.focus = function () {
      if (!_this.input) return;
      _this.input.focus();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Checkbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChangeProps = _props.onChange,
          value = _props.value,
          trueLabel = _props.trueLabel,
          falseLabel = _props.falseLabel,
          label = _props.label,
          disabled = _props.disabled;

      var _onChange = typeof onChangeProps === 'function' ? onChangeProps : function () {};

      return _react2.default.createElement(
        'div',
        { className: 'os-checkbox-container' },
        _react2.default.createElement(
          'label',
          null,
          _react2.default.createElement('input', {
            ref: function ref(input) {
              return _this2.input = input;
            },
            type: 'checkbox',
            checked: !!value,
            disabled: disabled,
            onChange: function onChange() {
              return _onChange(!_this2.props.value);
            }
          }),
          _react2.default.createElement(
            'span',
            { className: 'os-checkbox-label' },
            (value ? trueLabel : falseLabel) || label
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'error' },
          this.props.errorMessage
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      if (!state.prevDisabled && props.disabled && props.onChange) {
        try {
          props.onChange(false);
        } catch (err) {
          console.log(err);
        }
      }
      return {
        prevDisabled: props.disabled
      };
    }
  }]);
  return Checkbox;
}(_react2.default.Component), _class.propTypes = {
  value: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  trueLabel: _propTypes2.default.string,
  falseLabel: _propTypes2.default.string,
  label: _propTypes2.default.string,
  errorMessage: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
}, _temp2);
exports.default = Checkbox;